import { makeAutoObservable } from 'mobx';    
import { SBoolean, Comment, SNumber, OperationLog, SString } from '@/common/model';
import { projectApi } from './ProjectApi';
import { DateUtil } from '@/utils/DateUtil'; 
import { Util } from '@/utils/Util';
import { now } from 'moment';
import { Delivery } from '../Delivery/model';
import { demandApi } from '../demand/DemandApi';
import { Demand } from '../demand/model'; 


export class QueryProjectParam{
    searchKey:String;
    startDate:Date;
    endDate:Date; 
    constructor(searchKey:String, startDate: Date, endDate: Date) {
        this.searchKey = searchKey;
        this.startDate = startDate;
        this.endDate = endDate;
    }
}

export class Project{
    id:SNumber
    name:SString
    content:SString
    businessId:SNumber
    businessName:SString
    submitterId:SNumber
    submitterName:SString
    directorId:SNumber
    directorName:SString
    docLink:SString
    submitTime:Date
    finishTime:Date
    status:SNumber
    demands: DemandBrief[]
    deliveries:Delivery[]
    comments:Comment[]
    logs:OperationLog[]
}

export class DemandBrief{
    id:SNumber;
    content:string; 
    submitTime:Date;
    submitterId:SNumber;
    executorId:SNumber; 
    status:SNumber;
}

export class DeliveryBrief{
    id:SNumber;
    title:SString;
    finishTime:Date;
    submitTime:Date;
    submitterId:SNumber;
    members:SNumber [];//队长排第一个
    status:SNumber;
}

export class ProjectAddEditParam{
    id:SNumber
    name:SString
    content:SString
    directorId:SNumber
    submitterId:SNumber
    docLink:SString
    finishDate:Date
    demandIds:SNumber[]
    status:SNumber
}


export class FilterOptions{
    submitterId: SNumber
    status:SNumber[]//允许的状态，当为null时，指所有状态
}

export class SortOptions{
    bySubmitTime:SBoolean;
    bySubmitter:SBoolean;
    byDirector:SBoolean;
    byFinishTime:SBoolean;
    byStatus:SBoolean;
    order:'asc' | 'desc' | null;
}

const getDemandBrief = (demand:Demand):DemandBrief=>{
    
    const result = new DemandBrief();
    result.id = demand.id;
    result.content = demand.content;
    result.status =demand.status;
    result.submitTime = demand.submitTime;
    result.submitterId = demand.submitterId;

    return result;
}

export class ProjectPageModel{
    filterOptions:FilterOptions; 
    projects : Project[];
    sortOptions: SortOptions;
    filteredList: Project[]; 
    currentMonth:Date;
    isLoaded: SBoolean;
    demandList:DemandBrief[]; 
    constructor() {
        makeAutoObservable(this);
        this.filterOptions = {
            submitterId: null,
            status: []
        } 
        this.isLoaded =false;
        this.sortOptions =  {
            bySubmitTime: null,
            bySubmitter: null,
            byFinishTime: null,
            byDirector: null,
            byStatus: null,
            order: null,
        };
    }
    async initialize(){ 
        this.currentMonth = new Date(); 
        const allDemands :Demand [] = await demandApi.getDemandListData();
        this.demandList = allDemands.map(demand=>getDemandBrief(demand));
        this.reloadProjects();
    }
 
    async reloadProjects(){
        this.projects = await projectApi.getProjectListData(this.currentMonth);
        this.applyFilters();
        this.applySort();
        this.isLoaded = true;
    }
    
    applyFilters() {
        if(!this.projects) return;
        this.filteredList = []
        this.filteredList = this.projects.filter((project:Project) => {
            let fullfilled = true;

            if(this.filterOptions.submitterId != null){
                fullfilled = fullfilled && this.filterOptions.submitterId === project.submitterId; 
            }
            if(this.filterOptions.status != null && this.filterOptions.status.length > 0){
                fullfilled = fullfilled && this.filterOptions.status.includes(project.status);
            }
            return fullfilled;
        });
    }
    
    applySort() { 
        this.filteredList = this.filteredList.slice().sort((a, b) => {
            let compareResult = 0;
            if (this.sortOptions.bySubmitTime) {
                compareResult = a.submitTime.getTime() - b.submitTime.getTime();
            } else if (this.sortOptions.bySubmitter) {
                compareResult = Util.stringCompareTo(a.submitterName, b.submitterName)
            } else if (this.sortOptions.byDirector) {
                compareResult = Util.stringCompareTo(a.directorName, b.directorName)
            } else if (this.sortOptions.byStatus) {
                compareResult = Util.numberCompareTo(a.status, b.status)
            }
            return this.sortOptions.order === 'asc' ? compareResult : 0-compareResult;
        });
    }

    collapseAll() {
        // 折叠所有需求项
        (window as any).emitGlobalEvent('bugFolderAll')
    }

    refresh() {
        // 这里可以实现刷新需求列表的逻辑，比如从服务器获取最新数据
    }
}

export const projectPageModel = new ProjectPageModel();